// pascal case input filter to convert text to pascal case - new version created for vehicle types because existing one was not suitable
export function splitPascalCaseCustom() {

    // this replace function assumes required pattern is 1st matched char + " " + 2nd matched char
    function replacer(match) {
        return match.substr(0, 1) + " " + match.substr(1);
    }

    // Regex explanation: the first replace is to pre-pend any sequence of uppercase char (A-Z) followed by lower case (a-z) with a space
    // the second replace - for any matched pattern (each is pipe delimited, the first pattern selects a numeric digit followed by a letter),
    // call the replacer function - which will insert a space between the 2 matched chars
    return (input: string) => {
        return (!!input)
            ? input.replace(/([A-Z][a-z])/g, " $1").replace(/([0-9][A-Za-z]|[A-Za-z][0-9]|[a-z][A-Z]|[T][t])/g, replacer).trim()
            : "";
    }
}
